<script lang="ts">
const selected = false
</script>
<script setup lang="ts">
defineProps({
  fileId: null,
  conversationId: null,
  searchId: null,
  fractionalIndex: null
})

const { fileIdAttr, searchIdAttr, conversationIdAttr, sidebarChevronClass } = useGlobals()
const { state: gestureState } = useGestures()

// TODO
// - Specify whether this item is being dragged over
// - shift-select to select multiple items
// - selection state for whether this is before or after
//   another selection, giving a better 'multi-select' visual



const open = ref(false)
const elementId = useId()
const dragOver = computed(() => gestureState.value.sidebarItemDraggedOver?.elementId === elementId)
</script>

<template>
  <div :class="{ open }" class="sidebar-entry">
    <div
      :[dataAttr(fileIdAttr)]="fileId"
      :[dataAttr(searchIdAttr)]="searchId"
      :[dataAttr(conversationIdAttr)]="conversationId"
      :data-fractional-index="fractionalIndex"
      class="sidebar-entry-container"
      :class="{ dragOver, open }"
    >
      <div
        v-if="$slots.contents"
        class="sidebar-entry-chevron"
        :class="[sidebarChevronClass]"
        @click="open = !open"
      >
        <div class="sidebar-entry-chevron-inner">
          <icon-action
            v-if="open"
            size="xs"
            type="chevron-down"
          />
          <icon-action
            v-else
            size="xs"
            type="chevron-right"
          />
        </div>
      </div>
      <div v-else class="sidebar-entry-spacer" />
      <div class="sidebar-entry-item">
        <div class="sidebar-entry-item-inner">
          <slot name="item" />
        </div>
        <div class="sidebar-entry-item-bg" />
      </div>
    </div>
    <div
      v-if="$slots.contents && open"
      class="sidebar-entry-item-contents"
    >
      <slot name="contents" />
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.sidebar-entry-container
  @apply flex items-center gap-0.5
  @apply text-[#{$sidebar-t-item}] t-sidebar-item
  @apply -ml-[11px] my-0
  // @apply rounded-[#{$sidebar-br-item-hovered}]
  @apply cursor-pointer
  &.dragOver
    @apply bg-[#{$sidebar-bg-item-hovered}]

.sidebar-entry-chevron
  @apply flex items-center justify-center flex-none
  @apply relative
  @apply h-full
  @apply invisible
  @apply w-2 h-2
  @apply text-[#{$global-steel-primary}]

.sidebar-entry-chevron-inner
  @apply absolute
  @apply w-4 h-4
  &:hover
    @apply text-[#{$global-bg-icon-secondary}]

.sidebar-entry-container
  @apply flex
  &.open
    .sidebar-entry-chevron
      @apply visible
      @apply text-[#{$global-bg-icon-secondary}]
  &:hover:not(.open)
    .sidebar-entry-chevron
      @apply visible
      @apply text-[#{$global-bg-icon-secondary-alt}]

.sidebar-entry-spacer
  @apply w-2 h-2 flex-none

.sidebar-entry-item
  @apply w-full min-w-0 relative h-[22px] flex items-center

.sidebar-entry-item-inner
  @apply relative z-1 w-full min-w-0

.sidebar-entry-item-bg
  @apply absolute -top-[2px] -left-[1px] -right-[1px] -bottom-[2px] z-0 rounded-[6px]

.sidebar-entry:not(.selected)
  .sidebar-entry-item:hover
    .sidebar-entry-item-bg
      @apply bg-[#{$sidebar-bg-item-hovered}]

// selection: for selection, we give a different style based on whether you have a selection
// after you, or before you.

.sidebar-entry.selected.selected
  .sidebar-entry-item-bg
    @apply bg-$global-blue-primary

.sidebar-entry.selected:not(.open) + .sidebar-entry.selected:not(.open)
  .sidebar-entry-item-bg
    @apply rounded-t-none -top-[3px]
.sidebar-entry.selected:not(.open):has(+ .sidebar-entry.selected:not(.open))
  .sidebar-entry-item-bg
    @apply rounded-b-none -bottom-[3px]
    
</style>
